import { render, staticRenderFns } from "./RemolcadorForm.vue?vue&type=template&id=26545f09"
import script from "./RemolcadorForm.vue?vue&type=script&lang=js"
export * from "./RemolcadorForm.vue?vue&type=script&lang=js"
import style0 from "./RemolcadorForm.vue?vue&type=style&index=0&id=26545f09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports